import * as React from "react";
function SvgAttachment(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M18.364 5.636a4.947 4.947 0 010 7l-6.682 6.683a3.6 3.6 0 01-5.091 0 3.599 3.599 0 010-5.092L12 8.818A2.25 2.25 0 0115.182 12l-4.773 4.773L9.136 15.5l4.83-4.83c.35-.35-.286-.987-.636-.636L7.863 15.5c-.7.7-.7 1.846 0 2.546.7.7 1.846.7 2.546 0l6.682-6.682a3.153 3.153 0 000-4.455 3.153 3.153 0 00-4.455 0l-6.045 6.045-1.273-1.272 6.046-6.046a4.947 4.947 0 017 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgAttachment);
export default ForwardRef;
